export const environment = {
  "name": "develop",
  "production": false,
  "apiUrl": "https://api-dev.hirefit.net/api",
  "streaming": {
    "assemblyServiceUrl": "https://api-dev.hirefit.net/assembly",
    "defaultSampleRate": 16000
  },
  "paddle": {
    "serviceUrl": "https://api-dev.hirefit.net/paddle",
    "clientToken": "test_a541d35de3f869d285d66fd4ad4",
    "checkoutPageUrl": "http://localhost:4200/checkout",
    "plans": {
      "core": {
        "productId": "pro_01kw0nsv3qzhepk6g8w76d0hp6",
        "priceId": "pri_01kw0nvswh594xz721a5dbh9b1",
        "listPriceCents": 4900,
        "currency": "USD"
      },
      "pro": {
        "productId": "pro_01kw0nxczqcmbcah4cnjgm52c2",
        "priceId": "pri_01kw0nyeykh2s4k44wfw30gvfy",
        "listPriceCents": 8900,
        "currency": "USD"
      },
      "premium": {
        "productId": "pro_01kw0nzh2wvskmgdhy74d5shrg",
        "priceId": "pri_01kw0p0hqsx1b8c2nfa5ekqksb",
        "listPriceCents": 17900,
        "currency": "USD"
      }
    }
  },
  "google": {
    "clientId": "257079013936-g2ialbcq4qnq38o4osb228gb2uncigbn.apps.googleusercontent.com"
  }
};
